import api from './api';
import { API_ROUTES } from '@/lib/constants';
import type { ApiResponse, OrganizationSettings } from '@/types/table';

export type AssetKind = 'logo' | 'signature';

export const organizationSettingsService = {
  get: async (): Promise<ApiResponse<OrganizationSettings>> => {
    const response = await api.get(API_ROUTES.ORGANIZATION_SETTINGS);
    return response.data;
  },

  update: async (data: Partial<OrganizationSettings>): Promise<ApiResponse<OrganizationSettings>> => {
    const response = await api.put(API_ROUTES.ORGANIZATION_SETTINGS, data);
    return response.data;
  },

  uploadAsset: async (kind: AssetKind, file: File): Promise<ApiResponse<OrganizationSettings>> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post(`${API_ROUTES.ORGANIZATION_SETTINGS}/${kind}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  removeAsset: async (kind: AssetKind): Promise<ApiResponse<OrganizationSettings>> => {
    const response = await api.delete(`${API_ROUTES.ORGANIZATION_SETTINGS}/${kind}`);
    return response.data;
  },

  /** Build a public URL to fetch the asset stream (logo / signature). Append a cache-buster query string to force refresh. */
  assetUrl: (kind: AssetKind, cacheBuster?: string | number): string => {
    const apiBase = (import.meta.env.VITE_API_URL as string | undefined) || '/api/v1';
    const base = `${apiBase}${API_ROUTES.ORGANIZATION_SETTINGS}/${kind}/file`;
    return cacheBuster ? `${base}?v=${cacheBuster}` : base;
  },
};
